module.exports = __webpack_public_path__ + "img/icon_check.c08692a.png";